import Vue from 'vue'
import App from './App.vue'
import routes from './routes.js'
import BaiduMap from 'vue-baidu-map'
import VueNumber from 'vue-number-animation'

// import store from './store.js'
// Install BootstrapVue
import {
	BootstrapVue,
	IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
// Install BootstrapVue end
//

 Vue.use(VueNumber)
 

//router
const VueRouter = require('vue-router').default;
const router = new VueRouter({
	mode: 'history',
	routes: routes
})
Vue.use(VueRouter);
//router end

Vue.config.productionTip = false
new Vue({
	// store,
	router,
	render: h => h(App),
}).$mount('#app')
